import { LuSearch } from "@/Components/Icons/Icons.jsx";
export default {
  row1: [
    {
      column: "column1",
      highlight: true,
      columnWidth: "48%",
      rows: {
        row1: [
          {
            name: "supplier",
            actionText: "Supplier / Exporter",
            component: "typographytext",
          },
        ],
        row2: [
          {
            name: "supplierName",
            label: "Name",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCustomers",
            autofillTargets: {
              supplierAddress: "addressLine",
              supplierCity: "city",
              supplierCountry: "country",
            },
            endPointWithId : "getCustomersAddress"
          },
        ],
        row3: [
          {
            name: "supplierAddress",
            component: "textarea",
            // disabled: true,
            width: "100%",
            sx: {
              height: "10%",
              borderRadius: 10,
            },
          },
        ],
        row4: [
          {
            name: "supplierCity",
            label: "City",
            //  disabled:true,
            component: "text-field",
            type: "autocomplete",
            endpoint: "getCityMaster",
          },
        ],
        row5: [
          {
            name: "supplierCountry",
            label: "Country",
            component: "text-field",
            //  disabled:true,
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCountry",
          },
        ],
      },
    },
  ],
  row2: [
    {
      column: "column1",
      highlight: true,
      columnWidth: "48%",
      rows: {
        row1: [
          {
            name: "seller",
            actionText: "Seller",
            component: "typographytext",
          },
        ],
        row2: [
          {
            name: "sellerName",
            label: "Name",
            component: "text-field",
            //  disabled:true,
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCustomers",
            autofillTargets: {
              sellerAddress: "addressLine",
              sellerCity: "city",
              sellerCountry: "country",
            },
            endPointWithId : "getCustomersAddress"
          },
        ],
        row3: [
          {
            name: "sellerAddress",
            component: "textarea",
            // disabled: true,
            width: "100%",
            sx: {
              height: "10%",
              borderRadius: 10,
            },
          },
        ],
        row4: [
          {
            name: "sellerCity",
            label: "City",
            component: "text-field",
            //  disabled:true,
            type: "autocomplete",
            endpoint: "getCityMaster",
          },
        ],
        row5: [
          {
            name: "sellerCountry",
            label: "Country",
            component: "text-field",
            //  disabled:true,
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCountry",
          },
        ],
      },
    },
  ],
  row3: [
    {
      column: "column1",
      highlight: true,
      columnWidth: "48%",
      rows: {
        row1: [
          {
            name: "broker",
            actionText: "Broker",
            component: "typographytext",
          },
        ],
        row2: [
          {
            name: "brokerName",
            label: "Name",
            component: "text-field",
            //  disabled:true,
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCustomers",
            autofillTargets: {
              brokerAddress: "addressLine",
              brokerCity: "city",
              brokerCountry: "country",
            },
            endPointWithId : "getCustomersAddress"
          },
        ],
        row3: [
          {
            name: "brokerAddress",
            component: "textarea",
            // disabled: true,
            width: "100%",
            sx: {
              height: "10%",
              borderRadius: 10,
            },
          },
        ],
        row4: [
          {
            name: "brokerCity",
            label: "City",
            //  disabled:true,
            component: "text-field",
            type: "autocomplete",
            endpoint: "getCityMaster",
          },
        ],
        row5: [
          {
            name: "brokerCountry",
            label: "Country",
            component: "text-field",
            //  disabled:true,
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCountry",
          },
        ],
      },
    },
  ],
  row4: [
    {
      column: "column1",
      highlight: true,
      columnWidth: "48%",

      rows: {
        row1: [
          {
            name: "thirdparty",
            actionText: "Actual Seller / Third Party",
            component: "typographytext",
          },
        ],
        row2: [
          {
            name: "thirdPartyName",
            label: "Name",
            component: "text-field",
            //  disabled:true,
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCustomers",
            autofillTargets: {
              thirdPartyAddress: "addressLine",
              thirdPartyCity:"city",
              thirdPartyCountry:"country",
              thirdPartyState:"state",
              thirdPartyPinCode:"pincode",
            },
            endPointWithId : "getCustomersAddress"
          },
        ],
        row3: [
          {
            name: "thirdPartyAddress",
            component: "textarea",
            // disabled: true,
            width: "100%",
            sx: {
              height: "10%",
              borderRadius: 10,
            },
          },
        ],
        row4: [
          {
            name: "thirdPartyCity",
            label: "City",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getCity",
            useLinkedValue: "thirdPartyState",

            //  disabled:true,
          },
          {
            name: "thirdPartyPinCode",
            label: "PIN",
            component: "text-field",
            type: "autocomplete",

          },
        ],
        row5: [
          {
            name: "thirdPartyCountry",
            label: "Country",
            component: "text-field",
            //  disabled:true,
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCountry",
            linkedValue: "thirdPartyCountry",


          },
        ],
        row6: [
          {
            name: "thirdPartyState",
            label: "State",
            component: "text-field",
            //  disabled:true,
            type: "autocomplete",
            endpoint: "getState",
            useLinkedValue: "thirdPartyCountry",
            linkedValue : "thirdPartyState"
          },
        ],
      },
    },
  ],
  row5: [
    {
      column: "column1",
      columnWidth: "90%",
      rows: {
        row1: [
          {
            name: "IsManufacturer",
            checkboxLabel: "Use Supplier / Exporter as default manufacturer	",
            component: "checkboxbox",
            width:"40%"
          },
          {
            name: "createNewOrganization",
            label: "Create New Organization",
            component: "backlink",
            width:"40%",
            sx:{
              ml:"auto"
            },
            action: "navigate",
            navigateTo: "/organization/create-customer",

          }
        ],
      },
    },
  ],
};
